import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  computed,
  inject,
  OnInit,
  OnDestroy,
  signal,
} from "@angular/core";
import { Card } from "src/app/shared/components/card/card";
import { Icon } from "src/app/shared/components/utils/icon/icon";
import { RandomImageLoaderService } from "src/app/features/services/utils/random-image-loader-service";
import { Router } from "@angular/router";
import { TranslocoModule } from "@jsverse/transloco";
import { PianoAnalyticsService } from "src/app/core/services/piano-analytics";

@Component({
  selector: "app-home",
  imports: [Icon, Card, TranslocoModule],
  templateUrl: "./home.component.html",
  styles: [
    `
      @media (min-width: 1100px) {
        :host {
          display: flex;
          flex-direction: column;
          height: calc(100dvh - 7.5rem);
        }
      }
    `,
  ],
})
export class HomeComponent implements OnInit, AfterViewInit, OnDestroy {
  private readonly randomImageLoaderService = inject(RandomImageLoaderService);
  private readonly router = inject(Router);
  private readonly piano = inject(PianoAnalyticsService);
  private readonly cdr = inject(ChangeDetectorRef);
  image = computed(() => this.randomImageLoaderService.image());
  startAnimation = signal(false);

  ngOnInit(): void {
    this.piano.trackPageDisplay("home", "/");
  }

  ngAfterViewInit() {
    this.playAnimation();
  }

  playAnimation() {
    this.startAnimation.set(false);
    this.cdr.detectChanges();

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.startAnimation.set(true);
      });
    });
  }

  ngOnDestroy() {
    this.startAnimation.set(false);
  }

  cardDevelopmentClick() {
    this.router.navigate(["/development"]);
  }

  cardMobilityClick() {
    this.router.navigate(["/mobility"]);
  }

  cardJourneyClick() {
    this.router.navigate(["/journey"]);
  }
}
